//MAKE CHANGES TO PDP RECHARGE SECTION FOR CXT

$(document).ready(function () {

  if ($("recharge-subscription-widget").length > 0){

  const rechargeWidget = $("recharge-subscription-widget")[0];
  const shadowRoot = rechargeWidget.shadowRoot;
  var subby, onetimey;

  const isMemberKit = ($("recharge-subscription-widget").length > 0 && $(".product-kit").length > 0 && $(".logged-in-user.active-subscription-selected").length > 0);


  function constantlyUpdateStickyFooter(){

    try{
    	const selectedOption = $(shadowRoot).find(".rc-purchase-option[rc-selected]")[0];
    	const prices = $(selectedOption).find(".rc-price");
    	let pricey = null;
        let originalPrice = "";
    	let buttonText = "ADD TO CART";
    	if ($(prices).length > 1){
    		pricey = $(prices)[1];
    		if ($(".logged-in-user.active-subscription-selected")){ buttonText = "ADD TO SUBSCRIPTION"; }
            originalPrice = "<s>" + $(prices)[0].innerText.replace(".00","").replace(" ","") + "</s>";
    	} else {
    		pricey = $(prices)[0];
    	}
        const discountedPrice = pricey.innerText.replace(".00","").replace(", Discounted price:","");
    	$(".sticky-footer-price").html(originalPrice + "" + discountedPrice);
        $(".sticky-footer-price").attr("data-tc-pdp-options-subscribe-price",discountedPrice)
    	$("#stickyFooterAddToKit").html(buttonText);
    }catch(e){}
  
  }

  if (!isMemberKit){
    let stickyBoi = setInterval(constantlyUpdateStickyFooter, 1000);
  } else {
    $("body").on("click", "#stickyFooterAddToCart", function(){ $("#addToCartPdp").trigger("click"); });
  }


  if ($("body.logged-in-user.active-subscription-selected").length > 0){

	$("#stickyFooterAddToKit").off().on("click", function(){
		if ($("#addToCartPdp").is(":visible")){ $("#addToCartPdp").trigger("click"); }
		if ($("#addToKitPdp").is(":visible")){ $("#addToKitPdp").trigger("click"); }
	});

    function clickedSubscription(){
          $("#addToCartPdp, .product-form__quantity").addClass("d-none");
          $("#addToKitPdp").removeClass("d-none");
          document.getElementById('quantity_value').setAttribute("value", "1");
        document.getElementsByClassName('pdp__quantity_input')[0].value = '1';
    }

    function clickedOneTime(){
          $("#addToKitPdp").addClass("d-none");
          $("#addToCartPdp, .product-form__quantity").removeClass("d-none");
          document.getElementById('quantity_value').setAttribute("value", "1");
          document.getElementsByClassName('pdp__quantity_input')[0].value = '1';
    }
    

    if ( $(".product-single").length > 0){ //FOR SINGLES ONLY

      var loopIndy = setInterval(function(){

        if ($(shadowRoot).find(".rc-purchase-option__subscription .rc-purchase-option__selector").length > 0){
          clearInterval(loopIndy);
          subby = $(shadowRoot).find(".rc-purchase-option__subscription")[0];
          onetimey = $(shadowRoot).find(".rc-selection__onetime")[0];

          $(subby).off().on("click", function(){ clickedSubscription(); });
          $(onetimey).off().on("click", function(){ clickedOneTime(); });
          clickedSubscription();

        }
      }, 500);
    } //END FOR SINGLES ONLY



  //ADD TO KIT INSTEAD OF CART
  $(".product-single #addToKitPdp").on("click", function(){
     window.DefaultCustomerInfoObservable.subscribe(addToKitPdp);
  });




 } /// END ACTIVE USER LOGGED IN
    else {
      ///THIS IS ONLY TO CHANGE THE CTA FROM SUBSCRIBE
      if ( $(".product-single").length > 0){ //FOR SINGLES ONLY
        var loopIndy = setInterval(function(){
          if ($(shadowRoot).find(".rc-purchase-option__subscription .rc-purchase-option__selector").length > 0){
            clearInterval(loopIndy);
            subby = $(shadowRoot).find(".rc-purchase-option__subscription")[0];
            onetimey = $(shadowRoot).find(".rc-selection__onetime")[0];
            $(subby).off().on("click", function(){ $(".addto-cart-button .add_to_cart_label").html("SUBSCRIBE"); });
            $(onetimey).off().on("click", function(){ $(".addto-cart-button .add_to_cart_label").html("ADD TO CART"); });
            $(".addto-cart-button .add_to_cart_label").html("SUBSCRIBE");
          }
        }, 500);
      } //END FOR SINGLES ONLY
      
    }


//HACK TO FIX SAFARI TRANSPARENCY RADIO BUTTON ISSUES.  :(
var loopIndy2 = setInterval(function(){
  if ($(shadowRoot).find(".rc-purchase-option__subscription .rc-purchase-option__selector").length > 0){
    clearInterval(loopIndy2);
    const rcicon = $(shadowRoot).find(".rc-purchase-option__checked-indicator")[0];
    const rcicon2 = $(shadowRoot).find(".rc-purchase-option__checked-indicator")[1];
    const rechargeStyles = `
    <style>
    svg rect:nth-child(2){ stroke: #bfbfc0 !important; }
    </style>
    `;
    $(rechargeStyles).prependTo(rcicon.shadowRoot);
    $(rechargeStyles).prependTo(rcicon2.shadowRoot);
  }
}, 500);
    

  } // END IF RECHARGE SUBSCRIPTION WIDGET PRESENT
  
}); // END DOCUMENT READY